import { Theme } from '@ltvco/refresh-lib/theme';

export const getDeepSearchWrapperStyles = (theme: Theme) => ({
  paddingBottom: '0',
  height: 'calc(100vh - 80px)',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    marginTop: '55px',
    height: 'calc(100vh - 55px)',
  },
});

export const deepSearchContentStyles = {
  height: '100%',
};
